import { types, flow } from 'mobx-state-tree';
import axios from 'axios';
import { withAlertStore } from '@stores/alert/withAlertStore';
import { withMainStore } from '@stores/main/withMainStore';
import { ILocation } from '@/types/common';
import { withProfileStore } from '../profile/withProfileStore';
import { AUTOSUGGEST_DEFAUL_DATA, AUTOSUGGEST_DEFAUL_LIMIT } from './constants';
import { LocationSuggestionsReq } from './types';

const { model, frozen, maybeNull, number } = types;

export const HeremapsStore = model('HeremapsStore', {})
  .extend(withAlertStore)
  .extend(withMainStore)
  .extend(withProfileStore)
  .actions((self) => ({
    getAddress: flow(function* ({ lat, lng }: ILocation) {
      const lang = self.profileStore.user?.lang || 'en';
      const KEY = import.meta.env.VITE_HEREMAPS_API_KEY;
      const address = yield axios
        .get(
          `https://revgeocode.search.hereapi.com/v1/revgeocode?at=${lat}%2C${lng}&lang=${lang}&limit=1&apiKey=${KEY}`
        )
        .then((res) => (res.data.items ? res.data.items[0].address : null))
        .catch(self.mainStore.errorHandling);
      return address;
    }),
    getLocationSuggestions: flow(function* ({
      q,
      limit = AUTOSUGGEST_DEFAUL_LIMIT,
    }: LocationSuggestionsReq) {
      const cc = self.mainStore.selectedCountryCode?.countryCode;
      const lang = self.profileStore.user?.lang || 'en';

      if (!cc) {
        self.alertStore.showAlert('No country code was provided', 'error');
        return;
      }
      const KEY = import.meta.env.VITE_HEREMAPS_API_KEY;
      const address = yield axios
        .get(
          `https://autosuggest.search.hereapi.com/v1/autosuggest?at=${AUTOSUGGEST_DEFAUL_DATA[cc].coords}&limit=${limit}&lang=${lang}&q=${q}&apiKey=${KEY}`
        )
        .then((res) => res.data.items || null)
        .catch(self.mainStore.errorHandling);
      return address;
    }),
  }));
